






















import Vue from 'vue'
import { mapActions, mapGetters, mapState } from 'vuex'
import XIcon from '@/components/atoms/Icon/XIcon.vue'

export default Vue.extend({
  name: 'XError',
  components: { XIcon },
  computed: {
    ...mapState('errors', ['errors']),
    ...mapGetters('errors', ['hasError']),
  },
  methods: {
    ...mapActions('errors', ['clear']),
    onClose() {
      this.clear()
    },
    ref() {
      const { appError } = this.$refs
      return appError as HTMLElement
    },
    scrollToError() {
      this.$nextTick(() => this.ref().scrollIntoView())
    },
  },
  watch: {
    hasError(value) {
      if (value) {
        this.scrollToError()
      }
    },
  },
})
